import React from 'react';
import { Check } from 'lucide-react';
import { ServicePageLayout } from '../components/ServicePageLayout';
export function FullCarDetailPage() {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'Full Car Detail',
    provider: {
      '@type': 'LocalBusiness',
      name: "Mike's Pro Detail",
      telephone: '+18183819905'
    },
    areaServed: ['Camarillo', 'Thousand Oaks', 'Ventura County', 'Los Angeles'],
    description: 'Complete mobile full car detailing service combining deep interior cleaning and premium exterior wash, clay bar, and wax protection.'
  };
  return <ServicePageLayout title="Full Car Detail in Los Angeles & Ventura County" subtitle="Our most popular package. A complete bumper-to-bumper transformation combining our premium interior and exterior detailing services." metaDescription="Get a complete full car detail in Camarillo, Thousand Oaks, and Ventura County. Mobile service includes interior deep clean and exterior wax. Call (818) 381-9905." schema={schema} data-id="element-443">
      <p data-id="element-444">
        If you want your vehicle to look and feel as close to brand new as
        possible, our <strong data-id="element-445">Full Car Detail</strong> is the ultimate solution.
        This comprehensive package combines the deep-cleaning power of our
        interior detailing with the protective, gloss-enhancing benefits of our
        exterior detailing. At Mike's Pro Detail, we provide top-tier mobile
        auto detailing in Camarillo CA, Thousand Oaks, and throughout Ventura
        County, bringing a complete automotive makeover directly to your
        driveway or workplace.
      </p>

      <h2 data-id="element-446">What's Included in a Full Detail?</h2>
      <p data-id="element-447">
        The Full Detail package leaves no stone unturned. We spend hours
        meticulously cleaning, restoring, and protecting every surface of your
        vehicle.
      </p>

      <h3 data-id="element-448">Exterior Services:</h3>
      <ul className="space-y-4 my-6 list-none pl-0" data-id="element-449">
        <li className="flex items-start" data-id="element-450">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-451" />
          <span data-id="element-452">Wash method to safely remove surface dirt and grime.</span>
        </li>
        <li className="flex items-start" data-id="element-453">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-454" />
          <span data-id="element-455">
            <strong data-id="element-456">Decontamination & Clay Bar:</strong> Removal of embedded
            iron particles, tree sap, and road tar to leave the paint smooth.
          </span>
        </li>
        <li className="flex items-start" data-id="element-457">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-458" />
          <span data-id="element-459">
            <strong data-id="element-460">Wheel & Tire Detail:</strong> Deep cleaning of wheel
            barrels, faces, and tires, finished with a premium no-sling
            dressing.
          </span>
        </li>
        <li className="flex items-start" data-id="element-461">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-462" />
          <span data-id="element-463">
            <strong data-id="element-464">Paint Protection:</strong> Application of a high-grade
            hybrid ceramic wax or sealant for months of gloss and UV protection.
          </span>
        </li>
      </ul>

      <h3 data-id="element-465">Interior Services:</h3>
      <ul className="space-y-4 my-6 list-none pl-0" data-id="element-466">
        <li className="flex items-start" data-id="element-467">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-468" />
          <span className="font-[400]" data-id="element-469">
            Deep Vacuuming: Thorough removal of dirt and pet hair, followed
            steam clean carpets and cloth seats.
          </span>
        </li>
        <li className="flex items-start" data-id="element-470">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-471" />
          <span data-id="element-472">
            <strong data-id="element-473">Leather Treatment:</strong> Gentle cleaning and premium
            conditioning to restore softness and prevent cracking.
          </span>
        </li>
        <li className="flex items-start" data-id="element-474">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-475" />
          <span data-id="element-476">
            <strong data-id="element-477">Surface Sanitization:</strong> Steam cleaning of vents, cup
            holders, and dashboard to kill bacteria and remove sticky residues.
          </span>
        </li>
        <li className="flex items-start" data-id="element-478">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-479" />
          <span data-id="element-480">
            <strong data-id="element-481">Crystal Clear Glass:</strong> Streak-free cleaning of all
            interior and exterior windows and mirrors.
          </span>
        </li>
      </ul>

      <h2 data-id="element-482">The Ultimate Value and Convenience</h2>
      <p data-id="element-483">
        Booking a Full Car Detail is the most cost-effective way to completely
        reset your vehicle's condition. Whether you are preparing to sell your
        car, returning a lease, or simply want to fall in love with your daily
        driver all over again, this package delivers unmatched results. Plus,
        because we are a fully mobile operation, you don't have to waste your
        day sitting in a waiting room. We bring our own water and power,
        allowing you to continue working or relaxing at home while we transform
        your car.
      </p>

      <h2 data-id="element-484">Your Local Mobile Detailing Experts</h2>
      <p data-id="element-485">
        When residents search for "Car Detailing Camarillo" or "Mobile Detailing
        Ventura County", they consistently choose Mike's Pro Detail for our
        reliability, attention to detail, and exceptional customer service. From
        Calabasas to Moorpark, we are dedicated to providing the highest
        standard of mobile auto detailing available in Southern California.
      </p>
    </ServicePageLayout>;
}